import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import Colors from "../../../../../constants/Colors";
import {Spacing} from "../../../../../components";

const QuizResultItem = (props) => {

    const { userAnswer, correctAnswer, isCorrect } = props;

    return (
        <View style={{ flex: 1, minWidth: 400, alignItems: 'center' }}>

            <View style={[styles.container, { borderColor: Colors.quizCorrectResult, borderWidth: 1 }]}>
                <Text style={{ fontSize: 18, fontWeight: 'bold' }}>
                    Resposta Correta
                </Text>

                <Spacing height={12} />

                <Text style={{ fontSize: 16 }}>
                    {correctAnswer}
                </Text>
            </View>

            <View style={[styles.container, { borderColor: isCorrect === true ? Colors.quizCorrectResult : Colors.quizIncorrectResult, borderWidth: 1 }]}>
                <Text style={{ fontSize: 18, fontWeight: 'bold' }}>
                    Resposta Selecionada
                </Text>

                <Spacing height={12} />

                <Text style={{ fontSize: 16 }}>
                    { userAnswer }
                </Text>
            </View>

        </View>
    )

}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        minHeight: 120,
        minWidth: '80%',
        maxWidth: '80%',
        marginTop: 10,
        padding: 8,
        backgroundColor: 'white',
        borderColor: Colors.borderColor,
    },
    answerText: {
        fontSize: 18,
        textAlign: 'center',
        maxWidth: '68%'
    },
})

QuizResultItem.propTypes = {
    correctAnswer: PropTypes.string.isRequired,
    userAnswer: PropTypes.string.isRequired,
}

export default QuizResultItem;
